module.exports = __webpack_public_path__ + "communication-48-x-48.e61610058d5fee155167.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.woff
// module id = ../../../../../src/assets/fonts/line-icons-pro/communication/webfont/communication-48-x-48.woff
// module chunks = styles